export default "__VITE_ASSET__DLgPb4uT__"